export const scanThroughConstants = {
	UNKNOWN: 'unknown',
	QRCODE: 'qrcode',
	QRCODE_BY_EMPLOYEE: 'qrcode_by_employee',
	BUTTON: 'button',
};
